import { useState } from 'react'
import type { TrophyBadgeItem } from '../../logic/trophies'
import DateUtil from '../../util/DateUtil'
import AppIcon from '../icons/AppIcon'
import Popover from '../primitives/Popover'
import styles from './TrophyCase.module.css'

interface TrophyCaseProps {
  trophies: TrophyBadgeItem[]
}

export default function TrophyCase({ trophies }: TrophyCaseProps) {
  if (trophies.length === 0) return null
  const orderedTrophies = [...trophies].sort(
    (first, second) => Number(second.earned) - Number(first.earned),
  )

  return (
    <div className={styles.grid}>
      {orderedTrophies.map((item) => <TrophyPopover key={item.badge.id} item={item} />)}
    </div>
  )
}

function TrophyPopover({ item }: { item: TrophyBadgeItem }) {
  const [open, setOpen] = useState(false)
  const { badge, earned, earnedAt } = item

  return (
    <Popover
      open={open}
      onOpenChange={setOpen}
      side="bottom"
      trigger={
        <button
          type="button"
          className={[styles.trophy, !earned && styles.trophyLocked].filter(Boolean).join(' ')}
          aria-label={badge.name}
        >
          {badge.icon ? (
            <img src={badge.icon} alt="" />
          ) : (
            <AppIcon icon="mdi:image-outline" size={28} />
          )}
        </button>
      }
      className={styles.badgePopover}
    >
      <div className={styles.badgePopoverHead}>
        <div className={[styles.badgePopoverArt, !earned && styles.trophyLocked].filter(Boolean).join(' ')}>
          {badge.icon ? (
            <img src={badge.icon} alt="" />
          ) : (
            <AppIcon icon="mdi:image-outline" size={28} />
          )}
        </div>
        <div>
          <div className={styles.badgePopoverName}>{badge.name}</div>
          <div className={styles.badgePopoverStatus}>
            {earned && earnedAt
              ? `Earned · ${DateUtil.getRelativeTimeString(earnedAt)}`
              : 'Not yet earned'}
          </div>
        </div>
      </div>
      {badge.description && <p className={styles.badgePopoverDescription}>{badge.description}</p>}
      <div className={styles.badgePopoverRequirement}>{badge.getRequirementDescription()}</div>
    </Popover>
  )
}
